import useFullyFledgedField from '@gef-ui/form-core/hooks/field/useFullyFledgedField';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MuiFormLabel from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { useThemeProps } from '@mui/material/styles';
import PropTypes from 'prop-types';
import T from "ramda/es/T";
import always from "ramda/es/always";
import React from 'react';
import { HIDDEN_HELPER_TEXT, validationDisplayTypes } from '../constants';
import { defaultRadioCreateOptions, resolveHiddenProp, resolveValidationColor, useFieldDefaultValue } from '../utils';
export const COMPONENT_NAME = 'RadioGroup';
const RadioGroup = (inProps)=>{
    const props = useFieldDefaultValue({
        inProps,
        name: COMPONENT_NAME
    });
    const muiProps = useThemeProps({
        props,
        name: COMPONENT_NAME
    });
    const { fieldName, fieldIndices, initiallyDirty, isLoading, viewParser, modelParser, onChange, options, disabled, createOptions = defaultRadioCreateOptions, optionsFilter = T, createOptionsFilter = always(optionsFilter), defaultValue, label, valuePropName = 'code', labelPropName = 'name', labelVariant, validationDisplay, FormLabelProps = {}, FormControlProps = {}, size, ...other } = muiProps;
    const { value, errorMessage, handleChange, validationType, validateField, fieldId, disabled: disabledByAsyncValidation, hidden } = useFullyFledgedField({
        fieldName,
        fieldIndices,
        initiallyDirty,
        disabled,
        defaultValue,
        modelParser,
        viewParser
    });
    const validationColor = resolveValidationColor(validationType, validationDisplay);
    return /*#__PURE__*/ React.createElement(FormControl, {
        "data-loader": isLoading,
        size: size,
        ...resolveHiddenProp(hidden),
        ...FormControlProps
    }, label && /*#__PURE__*/ React.createElement(MuiFormLabel, {
        sx: (theme)=>({
                color: validationColor ? `${validationColor}.main` : undefined,
                ...!!other['data-gef-variant'] ? theme.typography.body2 : {
                    fontSize: theme.typography.pxToRem(12),
                    marginTop: '-10px'
                }
            }),
        variant: labelVariant,
        ...FormLabelProps
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            lineHeight: 'inherit',
            fontSize: 'inherit'
        }
    }, label)), /*#__PURE__*/ React.createElement(MuiRadioGroup, {
        id: fieldId,
        onChange: chainHandlers([
            handleChange,
            validateField,
            onChange
        ]),
        value: value ?? '',
        ...other
    }, createOptions({
        validationColor,
        validationType,
        value,
        disabled: disabledByAsyncValidation || disabled,
        optionsFilter: createOptionsFilter(props),
        valuePropName,
        labelPropName,
        size
    }, options)), HIDDEN_HELPER_TEXT.includes(validationDisplay) ? null : /*#__PURE__*/ React.createElement(FormHelperText, {
        validation: validationColor
    }, errorMessage));
};
RadioGroup.propTypes = {
    FormLabelProps: PropTypes.object,
    createOptions: PropTypes.func,
    createOptionsFilter: PropTypes.func,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    fieldIndices: PropTypes.arrayOf(PropTypes.number),
    fieldName: PropTypes.string,
    initiallyDirty: PropTypes.bool,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    labelPropName: PropTypes.string,
    labelVariant: PropTypes.string,
    modelParser: PropTypes.func,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    optionsFilter: PropTypes.func,
    validationDisplay: PropTypes.oneOf(Object.keys(validationDisplayTypes)),
    valuePropName: PropTypes.string,
    viewParser: PropTypes.func
};
export default RadioGroup;
